module.exports = __webpack_public_path__ + "img/sad_cloud.3229f6d8.svg";